import styled from 'styled-components';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import { rootTheme } from 'theme/rootTheme';
import { Renderer } from 'domains/reporter/RichTextEditor/renderer/Renderer';
import type { SlateContent } from 'domains/reporter/Reporter/types';

type MacroTooltipPreviewBodyProps = {
  macroContent: Nullable<SlateContent>;
  maxHeight: number;
  testID?: string;
};

export const MacroTooltipPreviewBody = ({
  macroContent,
  maxHeight,
  testID,
}: MacroTooltipPreviewBodyProps): React.ReactElement => {
  return (
    <Stack vertical data-stack-stretch css={{ minHeight: 0 }} space="none">
      <PreviewBox
        vertical
        data-testid={testID}
        data-scrollable={true}
        data-max-height={maxHeight}
        css={{
          flex: 1,
          minHeight: 0,
          maxHeight,
        }}
      >
        {macroContent != null ? (
          <Stack vertical space="medium" css={{ width: '100%', padding: '4px 0' }}>
            <Renderer content={macroContent} />
          </Stack>
        ) : (
          <EmptyState>No macro content available.</EmptyState>
        )}
      </PreviewBox>
    </Stack>
  );
};

const PreviewBox = styled(Stack)`
  background-color: ${Colors.gray4};
  border-radius: ${rootTheme.radius.sm};
  overflow: auto;
`;

const EmptyState = styled(Text).attrs({ variant: 'body2' })`
  color: ${Colors.gray8};
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 24px;
`;
